/**
 * CameraIcon - SVG icon component for camera/upload button
 * Pure presentation component with no business logic
 */

import React from 'react';

export default function CameraIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path
        d="M21 19V8a2 2 0 0 0-2-2h-3l-1-2H9L8 6H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h14a0 0 0 0 0 0 0z"
        stroke="#234"
        strokeWidth="0"
        fill="#2a4d69"
        opacity="0.95"
      />
      <circle cx="12" cy="13" r="3.5" fill="#fff" />
      <circle cx="12" cy="13" r="2" fill="#2a4d69" />
    </svg>
  );
}
